import Swiper from "swiper";
import {Navigation, Autoplay} from "swiper/modules";

const initJobOpeningsSections = () => {
    [...document.querySelectorAll('.job-openings-section')]
        .filter(item => item.dataset.init !== 'true')
        .forEach((item) => initJobOpeningsSection(item));
};

const initJobOpeningsSection = (section) => {
    section.dataset.init = true;
    const slider = section.querySelector('.job-openings-items');
    const swiper = new Swiper(slider, {
        modules: [Autoplay],
        slidesPerView: "auto",
        spaceBetween: 16,
        autoHeight: true,
        loop: true,
        autoplay: {
            delay: 3000,
        },
    });
};

export { initJobOpeningsSections };